
export type MediaInfoType = typeof MediaInfoType[keyof typeof MediaInfoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaInfoType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  GIF: 'GIF',
} as const;
